import { Component, inject } from '@angular/core';

import { AuthenticationService } from 'app/core/authentication';

@Component({
  selector: 'kh-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.less'],
  standalone: false
})
export class ForbiddenComponent {
  private readonly authenticationService = inject(AuthenticationService);

  public logOut(): void {
    this.authenticationService.logOut();
  }
}
